import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { useStaticQuery, graphql } from 'gatsby'
import SeminarCard from 'src/components/molecules/SeminarCard'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapperVW'
import HeadTitle from 'src/components/atoms/HeadTitle'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import ColorButton from 'src/components/atoms/ColorButton'
import { vwSize } from 'src/utils/vwCss'
import bgImage from 'src/images/top/seminar/bg.jpg'

const TopSeminars = () => {
  const {
    allMarkdownRemark: { edges: seminarData }
  } = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/event/" } }
        sort: { fields: [frontmatter___date], order: DESC }
        limit: 2
      ) {
        edges {
          node {
            frontmatter {
              title
              description
              thumbnail {
                childImageSharp {
                  fluid(maxWidth: 400) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              tags
              date(formatString: "YYYY.MM.DD")
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `)

  const seminarCardData = seminarData.map(
    ({
      node: {
        frontmatter: { title, description, thumbnail, tags, date },
        fields: { slug: to }
      }
    }) => ({
      title,
      description,
      thumbnail,
      tags,
      date,
      to
    })
  )

  return (
    <Container>
      <ContentsWrapper>
        <FadeDownWrap>
          <HeadingBorder heading="SEMINAR" />
        </FadeDownWrap>
        <FadeDownWrap>
          <HeadTitle as="h2" className={"g-h2"}>
            直近開催のセミナー
          </HeadTitle>
        </FadeDownWrap>
        <Contents>
          {seminarCardData.map(
            ({ title, description, thumbnail, tags, date, to }, i) => (
              <SeminarCard
                css={seminarCardCss}
                key={i}
                title={title}
                description={description}
                thumbnail={thumbnail}
                tags={tags}
                date={date}
                to={to}
              />
            )
          )}
        </Contents>
        <FadeDownWrap>
          <ButtonWrapper>
            <ButtonWrap className={"g-btn -blue"}>
              <ColorButton 
                text="すべてのセミナーを見る" 
                to="/event/" 
                color="blueSub"
                arrow={false}
              />
            </ButtonWrap>
          </ButtonWrapper>
        </FadeDownWrap>
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  background-image: url(${bgImage});
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    background: none;
  }
`

const Contents = styled.div`
`

const seminarCardCss = css`
  cursor: pointer;
`

const ButtonWrapper = styled.div`
  margin: ${vwSize(64, 'pc')}vw 0 0;
  text-align: center;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin: ${vwSize(48, 'sp')}vw 0 0;
  }
`
const ButtonWrap = styled.div`
`

export default TopSeminars
